import { Dispatch } from "@reduxjs/toolkit";

let appDispatch: Dispatch | null = null;

export function setAppDispatch(dispatch: Dispatch) {
  appDispatch = dispatch;
}

export function getAppDispatch(): Dispatch {
  if (!appDispatch) {
    throw new Error("Dispatch has not been set. Call setAppDispatch in a component.");
  }
  return appDispatch;
}
